<template>
  <div v-loading="loading">
    <table border="1">
        <tr>
          <th>快递单号(提)</th>
          <td>
            <!-- 原逻辑 展示 快递单号(提) -->
            <!--  <div>
              <span v-if="data.into && data.into.name">{{data.into.name}}</span>
              <span v-if="data.into && data.into.no">{{ data.into.no || ''}}  </span>
            </div>
            <div v-if="data.into && data.into.subs">
              <div v-for="item in data.into.subs" :key="item">
                <span>{{item}}</span>
              </div>
            </div> -->
            <!-- 新 逻辑 展示 快递单号(提) 2021-07-12  -->
            <div v-if="newData.in">
              <div v-for="item in newData.in" :key="item.sub_order">
                <span>{{item.courier_name}}</span>
                <span>{{item.sub_order}}</span>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th>快递单号(送)</th>
          <td>
            <!-- 原 逻辑 展示 快递单号(送)  -->
            <!-- <div>
              <span v-if="data.sendout && data.sendout.name">{{data.sendout.name}}</span>
              <span v-if="data.sendout && data.sendout.no">{{ data.sendout.no || ''}}  </span>
            </div>
            <div v-if="data.sendout && data.sendout.subs">
              <div v-for="item in data.sendout.subs" :key="item">
                <span>{{item}}</span>
              </div>
            </div> -->
            <!-- 新 逻辑 展示 快递单号(送)  2021-07-12 -->
            <div v-if="newData.out">
              <div v-for="item in newData.out" :key="item.sub_order">
                <span>{{item.courier_name}}</span>
                <span>{{item.sub_order}}</span>
              </div>
            </div>
            <div v-if="row.courier_mobile">物流联系电话:<span>{{row.courier_mobile}}</span></div>
          </td>
        </tr>
    </table>
  </div>
</template>
<script>
import { getBigafterListBox } from '@/models/aftersaleModel'
export default {
  props: ['row'],
  filters: {
    boxtype: function (value) {
      if (value === '1') {
        return '未到分仓'
      }
      if (value === '2') {
        return '已到分仓'
      }
      if (value === '-1') {
        return '分仓拒收'
      }
    }
  },
  data () {
    return {
      loading: false,
      data: {
        as_number: '',
        into: {},
        delivery_number: '',
        sendout: {},
        detail: []
      },
      // 重构接口 新的出参
      newData: {}
    }
  },
  // 运单号(送) 显示
  methods: {
    /* 更换接口 新 入参
      as_number 售后单号
      原入参
      let params = {
        id: this.row.id,
        order_type: 1
      }
    */
    async getData () {
      this.loading = true
      let params = {
        as_number: this.row.as_number
      }
      let data = await getBigafterListBox(params)
      this.boxDetail = {
        as_number: '',
        into: {},
        delivery_number: '', // 提
        sendout: {}, // 送
        detail: [], // 送
        as_type: ''
      }
      Object.assign(this.newData, data)
      this.loading = false
    }

  },
  created () {
    this.getData()
  }
}
</script>
<style lang="scss" scoped>
.title{
  padding: 15px 15px 15px 0;
  font-weight: bold;
  font-size: 12px;
}
table{
  border:1px solid rgb(145, 141, 141);
  border-collapse:collapse;
  width: 100%;
  font-size: 12px;
  th{
    width: 80px;
    background-color: rgb(243, 243, 243);
    vertical-align: middle;
    padding: 15px 7px;
    font-weight: bold;
  }
  td{
    padding: 15px 7px;
    text-align: left;
    vertical-align: middle;
    span{
      font-size: 12px;
      display: inline-block;
      margin-right: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/bigAftersale/waybillDetial.vue